module.exports = __webpack_public_path__ + "media/images/notifications/icon_not_3-a9e56afab5bfa12408eef1184b85f5a1.svg";